// extracted by mini-css-extract-plugin
export default {"description":"AssetNumbersModal_description__cvrjh","assetRow":"AssetNumbersModal_assetRow__tsRDW"};